import { styled, Style } from 'inlines'
import { AddCircleIcon } from './AddCircleIcon.js'
import { ForwardIcon } from './ForwardIcon.js'
import { createElement } from 'react'
import { colors } from '../../utils/colors.js'
import { AddIcon } from './AddIcon.js'
import { BackIcon } from './BackIcon.js'
import { CardIcon } from './CardIcon.js'
import { CheckCircledIcon } from './CheckCircledIcon.js'
import { CheckIcon } from './CheckIcon.js'
import { CheckboxOffIcon } from './CheckboxOffIcon.js'
import { ChevronDownIcon } from './ChevronDownIcon.js'
import { ChevronLeftIcon } from './ChevronLeftIcon.js'
import { ChevronRightIcon } from './ChevronRightIcon.js'
import { ChevronUpIcon } from './ChevronUpIcon.js'
import { CloseIcon } from './CloseIcon.js'
import { CollapseIcon } from './CollapseIcon.js'
import { EarthIcon } from './EarthIcon.js'
import { ErrorIcon } from './ErrorIcon.js'
import { ExtendIcon } from './ExtendIcon.js'
import { GlobeIcon } from './GlobeIcon.js'
import { InfoIcon } from './InfoIcon.js'
import { LanguageIcon } from './LanguageIcon.js'
import { LocationIcon } from './LocationIcon.js'
import { MenuIcon } from './MenuIcon.js'
import { NoteIcon } from './NoteIcon.js'
import { OutIcon } from './OutIcon.js'
import { PauseIcon } from './PauseIcon.js'
import { ReloadIcon } from './ReloadIcon.js'
import { RemoveIcon } from './RemoveIcon.js'
import { ReplayIcon } from './ReplayIcon.js'
import { VolumeIcon } from './VolumeIcon.js'
import { VolumeOffIcon } from './VolumeOffIcon.js'
import { PlayIcon } from './PlayIcon.js'

const iconTypes = {
  addCircleIcon: AddCircleIcon,
  addIcon: AddIcon,
  backIcon: BackIcon,
  cardIcon: CardIcon,
  checkboxOffIcon: CheckboxOffIcon,
  checkCircledIcon: CheckCircledIcon,
  checkIcon: CheckIcon,
  chevronDownIcon: ChevronDownIcon,
  chevronLeftIcon: ChevronLeftIcon,
  chevronRightIcon: ChevronRightIcon,
  chevronUpIcon: ChevronUpIcon,
  closeIcon: CloseIcon,
  collapseIcon: CollapseIcon,
  earthIcon: EarthIcon,
  errorIcon: ErrorIcon,
  extendIcon: ExtendIcon,
  forwardIcon: ForwardIcon,
  globeIcon: GlobeIcon,
  infoIcon: InfoIcon,
  languageIcon: LanguageIcon,
  locationIcon: LocationIcon,
  menuIcon: MenuIcon,
  noteIcon: NoteIcon,
  outIcon: OutIcon,
  pauseIcon: PauseIcon,
  playIcon: PlayIcon,
  reloadIcon: ReloadIcon,
  removeIcon: RemoveIcon,
  replayIcon: ReplayIcon,
  volumeIcon: VolumeIcon,
  volumeOffIcon: VolumeOffIcon,
}

type IconProps = {
  color?: string
  type: keyof typeof iconTypes
  width?: number
  height?: number
  style?: Style
}

export const Icon = ({
  type,
  color = colors.white,
  width = 24,
  height = 24,
  style,
}: IconProps) => {
  const el = iconTypes[type]

  return (
    <styled.svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ minWidth: width, minHeight: height, ...style }}
    >
      {createElement(el, { color: color })}
    </styled.svg>
  )
}
